module.exports = __webpack_public_path__ + "assets/img/2.9a101328.png";